import { Action, Dispatch } from "redux";
import { Auth } from "aws-amplify";
import { ErrorResponseType } from "@emisgroup/cohort-builder-kit";
import { ErrorAlertSlice } from "../components/ErrorAlert/Index";
import { ProgressSpinnerSlice } from "../components/ProgressSpinner/Index";
import { setUnauthorizedMessage } from "../utilities/HttpRequest/Script";
import { ErrorAlertType } from "../components/ErrorAlert/redux/Types";
import { ErrorMessageGroup } from "./ErrorMessages";

export interface errorMsgType {
  title: string;
  msg: string;
}

/**
 * Matches the relevant message with status code
 * @param statusCode - current error status
 * @param errorType - error type
 * @returns - title and msg
 */
const getErrorMessage = (statusCode: string, errorType: string): errorMsgType => {
  if (ErrorMessageGroup[errorType][statusCode]) {
    return ErrorMessageGroup[errorType][statusCode];
  } else if (ErrorMessageGroup["CommonErrMsg"][statusCode]) {
    return ErrorMessageGroup["CommonErrMsg"][statusCode];
  }
  else {
    return ErrorMessageGroup["CommonErrMsg"]["Empty"];
  }
};

/**
 * To handle the api response exception
 * @param ex exception
 * @param dispatch function to dispatch
 */
export const handleException = (err: ErrorResponseType, dispatch: Dispatch<Action>, errorType: string): void => {
  dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
  const status = typeof (err) === "object" && err.data.errors &&
    (err.data.errors[0].status?.toString());
  if (status) {
    const data = getErrorMessage("E" + status, errorType);
    const errorContent = {
      title: data.title,
      message: [data.msg],
      type: ErrorAlertType.ERROR
    };
    dispatch(ErrorAlertSlice.actions.createErrorAlert(errorContent));
  }

  if (status === "401") {
    Auth.signOut();
    return setUnauthorizedMessage(dispatch);
  }
};
